import { useEffect, useState } from "react";
import { toast } from "sonner";
import { CalendarCheck } from "lucide-react";
import { api, errMsg } from "@/lib/api";

export const GoogleCalendarCard = () => {
  const [st, setSt] = useState(null);
  const load = () => api.get("/admin/google/status").then((r) => setSt(r.data)).catch(() => {});
  useEffect(() => {
    load();
    const g = new URLSearchParams(window.location.search).get("google");
    if (g === "connected") toast.success("Połączono z Kalendarzem Google");
    if (g === "error") toast.error("Nie udało się połączyć z Kalendarzem Google");
    if (g) window.history.replaceState({}, "", "/admin");
  }, []);

  const connect = async () => {
    try { const { data } = await api.get("/admin/google/auth-url"); window.location.href = data.url; }
    catch (e) { toast.error(errMsg(e)); }
  };
  const disconnect = async () => { await api.post("/admin/google/disconnect"); load(); };
  if (!st) return null;

  return (
    <div data-testid="google-calendar-card" className="panel p-6 flex flex-wrap items-center justify-between gap-4">
      <div className="flex items-center gap-4">
        <CalendarCheck className="text-primary" size={28} strokeWidth={1.5} />
        <div>
          <div className="font-semibold">Kalendarz Google</div>
          <div data-testid="google-status" className="text-xs text-muted-foreground">
            {!st.configured ? "Brak kluczy Google – dodaj GOOGLE_CLIENT_ID i GOOGLE_CLIENT_SECRET."
              : st.connected ? `Połączono: ${st.email || "konto Google"}. Każda rezerwacja trafia do kalendarza.`
              : "Nie połączono. Rezerwacje nie są zapisywane w kalendarzu."}
          </div>
        </div>
      </div>
      {st.connected
        ? <button data-testid="google-disconnect-button" onClick={disconnect} className="px-4 py-2 rounded-md border border-white/15 text-sm hover:border-red-400">Rozłącz</button>
        : <button data-testid="google-connect-button" disabled={!st.configured} onClick={connect} className="btn-y px-4 py-2 text-sm">Połącz z Google</button>}
    </div>
  );
};
